// Save data with expiration (in milliseconds)
export function setWithExpiry(key, value, ttl) {
  const now = new Date();

  const item = {
    value: JSON.stringify(value), // 👈 store value as JSON string
    expiry: now.getTime() + ttl,
  };

  localStorage.setItem(key, JSON.stringify(item));
}


// Retrieve and auto-remove if expired
export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr); // 👈 parse it as an object
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    // ✅ This must be parsed JSON as well
    return typeof item.value === "string" ? JSON.parse(item.value) : item.value;
  } catch (err) {
    console.error("Failed to parse item from localStorage", err);
    return null;
  }
}

